module.exports = __webpack_public_path__ + "static/media/grey_card.png";